import { useState, useEffect } from 'react'
import { Grid } from '@mui/material'

import Dialog from './Dialog'
import Select from './Select'
import InputField from './InputField'
import { titlesImpostazioni } from '../settings/settings'

const mailFroms = ['iscrizioni', 'spostamenti', 'risultati', 'arbitri']

const DialogImpostazioniMailTest = ({ open, handleClose, triggerFunction }) => {
  const [mailTestFrom, setMailTestFrom] = useState()
  const [mailTestTo, setMailTestTo] = useState()

  useEffect(() => {
    setMailTestFrom()
    setMailTestTo()
  }, [open])

  return (
    <Dialog
      open={open}
      handleClose={handleClose}
      triggerFunction={() => triggerFunction(mailTestFrom, mailTestTo)}
      title={titlesImpostazioni.titleMailTest}
      textConfirm='Invia'
    >
      Prima di procedere, assicurati di aver salvato le impostazioni nella
      schermata precedente.
      <br />
      <br />
      <Grid container alignItems='center' spacing={2} sx={{ width: '100%' }}>
        <Grid size={12}>
          <Select
            id='mail-test-from'
            label='Mittente'
            value={mailTestFrom}
            options={mailFroms}
            optionLabels={mailFroms?.map(x => `Casella ${x}`)}
            onChange={setMailTestFrom}
          />
        </Grid>
        <Grid size={12}>
          <InputField
            id='mail-test-to'
            label='Destinatario'
            value={mailTestTo}
            onChange={setMailTestTo}
          />
        </Grid>
      </Grid>
    </Dialog>
  )
}

export default DialogImpostazioniMailTest
